import React from 'react';
import { Newsletters } from '../../dashboard/components';
import styles from './EnterpriseContentPage.module.css';

export default function EnterpriseNewslettersPage() {
  return (
    <div className={styles.page}>
      <Newsletters />
    </div>
  );
}
